import * as THREE from 'three';

export const createBasicWireframeMaterial = (color = '#00ff00', opacity = 0.5) => {
  return new THREE.LineBasicMaterial({
    color,
    transparent: true,
    opacity
  });
};

export const createHexagonMaterial = (color = '#00ff00', opacity = 0.02, side = THREE.DoubleSide) => {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side
  });
};

export const createPyramidMaterial = (color = '#00ff00', opacity = 0.8) => {
  return new THREE.MeshBasicMaterial({
    color,
    wireframe: true,
    transparent: true,
    opacity
  });
};